var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import 'bootstrap/js/dist/dropdown';
//import 'bootstrap/js/dist/util';
//import 'jquery';
//import $ from 'jquery';
import '../scss/site.scss';
export function initLazyLoading(config) {
    let pageNumber = 1;
    const cardGrid = document.querySelector(config.gridId);
    let isLoading = false;
    if (!cardGrid) {
        console.error(`Element with selector "${config.gridId}" not found.`);
        return;
    }
    const onScroll = () => __awaiter(this, void 0, void 0, function* () {
        const scrollTop = window.scrollY || document.documentElement.scrollTop;
        const windowHeight = window.innerHeight;
        const documentHeight = document.documentElement.scrollHeight;
        // Trigger loading when scrolled near the bottom (within 100px)
        if (!isLoading && scrollTop + windowHeight >= documentHeight - 100) {
            isLoading = true;
            try {
                const url = config.urlFn(pageNumber);
                const response = yield fetch(url);
                const data = yield response.text();
                if (data.trim() === '') {
                    // Stop listening for scroll events if no more content
                    window.removeEventListener('scroll', onScroll);
                    return;
                }
                // Append new content to the grid
                cardGrid.insertAdjacentHTML('beforeend', data);
                pageNumber++;
            }
            catch (error) {
                //console.error('Failed to load data:', error);
                isLoading = false;
            }
            finally {
                isLoading = false;
            }
        }
    });
    // Add the scroll event listener
    window.addEventListener('scroll', onScroll);
}
export function initReadMore(config) {
    var _a, _b;
    // Set default values if not provided
    config.btn = (_a = config.btn) !== null && _a !== void 0 ? _a : '.read-more-btn';
    config.txt = (_b = config.txt) !== null && _b !== void 0 ? _b : '.read-more-txt';
    const wrapper = document.querySelector(config.id);
    if (!wrapper) {
        console.error(`Element with selector "${config.id}" not found.`);
        return;
    }
    const button = wrapper.querySelector(config.btn);
    const text = wrapper.querySelector(config.txt);
    if (!button || !text) {
        console.error('Button or text container not found within the wrapper.');
        return;
    }
    button.addEventListener('click', () => {
        if (text.classList.contains('collapsed')) {
            button.textContent = 'See less';
            text.classList.remove('collapsed');
            text.classList.add('expanded');
        }
        else {
            button.textContent = 'See more';
            text.classList.remove('expanded');
            text.classList.add('collapsed');
        }
    });
}
export function initButtonLoading(config) {
    let pageNumber = 1;
    const cardGrid = document.querySelector(config.gridId);
    const button = document.querySelector(config.buttonId);
    let isLoading = false;
    if (!cardGrid) {
        console.error(`Element with selector "${config.gridId}" not found.`);
        return;
    }
    if (!button) {
        console.error(`Element with selector "${config.buttonId}" not found.`);
        return;
    }
    const onButtonClick = () => __awaiter(this, void 0, void 0, function* () {
        console.log('onclick');
        // Trigger loading when scrolled near the bottom (within 100px)
        if (!isLoading) {
            isLoading = true;
            try {
                const url = config.urlFn(pageNumber);
                const response = yield fetch(url);
                const data = yield response.text();
                if (data.trim() === '') {
                    // Stop listening for scroll events if no more content
                    button.removeEventListener('onclick', onButtonClick);
                    button.remove();
                    return;
                }
                // Append new content to the grid
                cardGrid.insertAdjacentHTML('beforeend', data);
                pageNumber++;
            }
            catch (error) {
                //console.error('Failed to load data:', error);
                isLoading = false;
            }
            finally {
                isLoading = false;
            }
        }
    });
    // Add the scroll event listener
    button.addEventListener('click', onButtonClick);
}
